import axios from "axios";
import { liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}/v1/adminAyats`;
const CREATE_AYAT = `${MAIN_URL}/createAyat`;
const GET_AYATS = `${MAIN_URL}/getAyats`;
const GET_AYAT_BY_ID = `${MAIN_URL}/getAyatById`;
const UPDATE_AYAT = `${MAIN_URL}/updateAyat`;
const DELETE_AYAT = `${MAIN_URL}/deleteAyat`;
const CREATE_MAIN = `${MAIN_URL}/mainpage`;
const GET_MAIN_PAGE = `${MAIN_URL}/getMainPage`;
const UPDATE_AYATS_STATUS = `${MAIN_URL}/updateAyatStatus`;


export async function updateAyatStatus(token, ayatIds, status) {
  try {
    const response = await axios.post(UPDATE_AYATS_STATUS, {ayatIds,status}, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating Ayat status:', error);
    throw error;
  }
};
// Create a new Ayat
export async function createAyat(token, data) {
  try {
    const response = await axios.post(CREATE_AYAT, data, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error creating Ayat:", error);
    return { Result: false, Msg: "Error creating Ayat" };
  }
}

// Get all Ayats
export async function getAyats(token) {
  try {
    const response = await axios.get(GET_AYATS,{
        headers: {
          token: token,
        },
      });
    return response.data;
  } catch (error) {
    console.log("Error fetching Ayats:", error);
    return { Result: false, Msg: "Error fetching Ayats" };
  }
}

// Get Ayat by ID
export async function getAyatById(token,id) {
  try {
    const response = await axios.get(`${GET_AYAT_BY_ID}/${id}`,{
        headers: {
          token: token,
        },
      });
    return response.data;
  } catch (error) {
    console.log("Error fetching Ayat by ID:", error);
    return { Result: false, Msg: "Error fetching Ayat by ID" };
  }
}

// Update Ayat
export async function updateAyat(token, id, data) {
  try {
    const response = await axios.put(`${UPDATE_AYAT}/${id}`, data, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error updating Ayat:", error);
    return { Result: false, Msg: "Error updating Ayat" };
  }
}

// Delete Ayat
export async function deleteAyat(token, id) {
  try {
    const response = await axios.delete(`${DELETE_AYAT}/${id}`, {
      headers: {
        token: token,
      },
    });
    return response.data;
  } catch (error) {
    console.log("Error deleting Ayat:", error);
    return { Result: false, Msg: "Error deleting Ayat" };
  }
}



// Create a new MAIN PAGE
export async function createMainPage(token, data) {
    try {
      const response = await axios.post(CREATE_MAIN, data, {
        headers: {
          token: token,
        },
      });
      return response.data;
    } catch (error) {
      console.log("Error creating MAn:", error);
      return { Result: false, Msg: "Error creating mian" };
    }
  }

  export async function getMainPage(token) {
    try {
      const response = await axios.get(GET_MAIN_PAGE,{
          headers: {
            token: token,
          },
        });
      return response.data;
    } catch (error) {
      console.log("Error fetching Ayats:", error);
      return { Result: false, Msg: "Error fetching Ayats" };
    }
  }

  export async function getHeroImages(token) {
    try {
      const response = await axios.get(`${MAIN_URL}/getHeroImages`, {
        headers: {
          token: token,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching hero images:", error);
      return { success: false, message: "Error fetching hero images" };
    }
  }

  export async function deleteHeroImage(token, id) {
    try {
      const response = await axios.delete(`${MAIN_URL}/deleteHeroImage/${id}`, {
        headers: {
          token: token,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting hero image:", error);
      return { success: false, message: "Error deleting hero image" };
    }
  }

  const CELEBRATION_URL = `${liveURL}/v1/adminCelebration`;

  export async function getCelebrationConfig(token) {
    try {
      const response = await axios.get(`${CELEBRATION_URL}/getConfig`, {
        headers: {
          token: token,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching celebration config:", error);
      return { success: false, message: "Error fetching celebration config" };
    }
  }

  export async function updateCelebrationConfig(token, data) {
    try {
      const response = await axios.post(`${CELEBRATION_URL}/updateConfig`, data, {
        headers: {
          token: token,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating celebration config:", error);
      return { success: false, message: "Error updating celebration config" };
    }
  }
  